import { createRoot } from 'react-dom/client';
import { store } from 'app/store/configureStore';
import { history } from 'app/store/browserHistory';
import { initHeap } from 'app/shared/utils/heap';
import { initSentry } from 'app/shared/utils/sentry';
import { initUILibAnalytics } from 'app/shared/utils/analytics/u21Analytics';
import getFromProcessEnv from 'app/shared/utils/getFromProcessEnv';

import { App } from 'app/components/App';
import { ConnectedRouter } from 'connected-react-router';
import { ErrorBoundary } from 'app/components/ErrorBoundary';
import { Provider } from 'react-redux';
import { U21ComponentLibraryWrapper } from 'app/components/U21ComponentLibraryWrapper';
import AppProvider from 'app/shared/providers/AppProvider';
import AuthProvider from 'app/shared/providers/AuthProvider';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from 'app/cache/queryClient';

import '@fontsource/source-sans-pro/latin.css';
import 'app/styles/base.scss';
import 'cropperjs/dist/cropper.css';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/lib/codemirror.css';
import 'react-image-crop/dist/ReactCrop.css';
import 'app/modules/notes/styles/react-draft-wysiwyg.css';
import '@u21/rich-text-editor/dist/styles.css';
import '@xyflow/react/dist/style.css';

const heapId = getFromProcessEnv('REACT_APP_HEAP_ID');
initHeap(heapId);
initSentry();
initUILibAnalytics();

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools />
      <U21ComponentLibraryWrapper>
        <ConnectedRouter history={history}>
          <ErrorBoundary>
            <AppProvider>
              <AuthProvider>
                <App />
              </AuthProvider>
            </AppProvider>
          </ErrorBoundary>
        </ConnectedRouter>
      </U21ComponentLibraryWrapper>
    </QueryClientProvider>
  </Provider>,
);
